import { render, staticRenderFns } from "./DepartmentInfo.vue?vue&type=template&id=ce10cd86"
import script from "./DepartmentInfo.vue?vue&type=script&lang=js"
export * from "./DepartmentInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports